export class ReplyForm {
  public reference?: string;
  public country?: string;
  public city?: string;
  public street?: string;
  public houseNumber?: string;
  public postalCode?: string;
  public phoneNumber?: string;
  public extraField?: boolean;
}
